import { render, staticRenderFns } from "./DetailPart.vue?vue&type=template&id=2bf102ca&scoped=true&"
import script from "./DetailPart.vue?vue&type=script&lang=ts&"
export * from "./DetailPart.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPart.vue?vue&type=style&index=0&id=2bf102ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf102ca",
  null
  
)

export default component.exports